<template>
  <div>
    <el-row style="margin-bottom: -20px;">
      <h3>供应商名称：{{ this.supplierName }}</h3>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="medium" @click="addLicense" style="margin-top: 20px">新增资质</el-button>
      </el-col>
    </el-row>
    <el-table stripe border style="margin-top: 20px" :data="tableData">
      <el-table-column type="index" label="序号" width="50"></el-table-column>
      <el-table-column label="名字">
        <template slot-scope="scope">
          <span :style="setFontColor(scope.row)">
            {{ scope.row.NAME }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="过期日期">
        <template slot-scope="scope">
          <span :style="setFontColor(scope.row)">
            {{ scope.row.EXPIRE_DATE == "" ? "长期" : scope.row.EXPIRE_DATE }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button icon="el-icon-view" size="small" @click="openLicense(scope.row)" type="text">查看资质凭证</el-button>
          <el-button icon="el-icon-edit" size="small" @click="editLicense(scope.row)" type="text">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :visible.sync="addDialog" title="新增资质" @close="close('addForm')" width="400px" center>
      <el-form ref="addForm" :model="addForm" :label-width="formLableWidth" label-suffix="：" :rules="!addForm.longTime ? rules1 : rules2">
        <el-form-item label="资质名称" prop="QUALIFY_NAME">
          <el-input v-model="addForm.QUALIFY_NAME"></el-input>
        </el-form-item>
        <el-form-item label="到期日期" prop="EXPIRE_DAY">
          <el-checkbox v-model="addForm.longTime" style="line-height: 40px; margin-right: 5px; float: left" width="20%"
            @change="(v) => onLongTimeChecked('addForm', v)">
            长期
          </el-checkbox>
          <el-date-picker v-model="addForm.EXPIRE_DAY" align="right" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
            :picker-options="pickerOptions1" style="width: 70%; float: right" v-if="!addForm.longTime">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button class="operate-btn" @click="close('addForm')">取消</el-button>
        <el-button class="operate-btn" @click="submitAdd">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="editDialog" title="修改资质" @close="close('editForm')" width="400px" center>
      <el-form ref="editForm" :model="editForm" :label-width="formLableWidth" label-suffix="：" :rules="!editForm.longTime ? rules1 : rules2">
        <el-form-item label="资质名称" prop="QUALIFY_NAME">
          <el-input v-model="editForm.QUALIFY_NAME"></el-input>
        </el-form-item>
        <el-form-item label="到期日期" prop="EXPIRE_DAY">
          <el-checkbox v-model="editForm.longTime" style="line-height: 40px; margin-right: 5px; float: left" width="20%"
            @change="(v) => onLongTimeChecked('editForm', v)">
            长期
          </el-checkbox>
          <el-date-picker v-model="editForm.EXPIRE_DAY" align="right" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
            :picker-options="pickerOptions1" style="width: 70%; float: right" v-if="!editForm.longTime">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button class="operate-btn" @click="close('editForm')">取消</el-button>
        <el-button class="operate-btn" @click="submitEdit">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import date from '@/assets/common/date';

export default {
  data() {
    return {
      tableData: [],
      addDialog: false,
      editDialog: false,
      addForm: {
        QUALIFY_NAME: '',
        longTime: false,
      },
      editForm: {
        QUALIFY_NAME: '',
        longTime: false,
      },
      supplierName: sessionStorage.getItem('supplierNameAboutLicense') || '',
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now();// 如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
      formLableWidth: '100px',
      rules1: {
        QUALIFY_NAME: [
          { required: true, message: '请输入资质名称', trigger: 'blur' },
        ],
        EXPIRE_DAY: [
          { required: true, message: '请选择到期日期', trigger: 'change' },
        ],
      },
      rules2: {
        QUALIFY_NAME: [
          { required: true, message: '请输入资质名称', trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    onLongTimeChecked(formName, v) {
      if (v) this[formName].EXPIRE_DAY = '';
    },
    // ------------------------------新增
    addContract() {
      this.addFormVisible = true;
    },
    setFontColor({ FLAG, EXPIRE_DATE }) {
      if (FLAG === 1) {
        return {
          color: '#FF7F00',
        };
      } if (FLAG === 2) {
        if (EXPIRE_DATE === '') {
          return {
            color: '#008000',
          };
        }
        return {
          color: '#FF0000',
        };
      }
    },
    editLicense({ ID, NAME, EXPIRE_DATE }) {
      this.editForm = {
        QUALIFY_ID: ID, QUALIFY_NAME: NAME, EXPIRE_DAY: EXPIRE_DATE, longTime: !EXPIRE_DATE,
      };
      this.editDialog = true;
    },
    submitEdit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          const data = {
            SERVICE_ID: '10002',
            OTYPE: 4,
            QUALIFY_ID: this.editForm.QUALIFY_ID,
            QUALIFY_NAME: this.editForm.QUALIFY_NAME,
            EXPIRE_DAY: this.editForm.longTime ? '' : date(this.editForm.EXPIRE_DAY, '%F'),
          };
          http.post(data).then((result) => {
            this.$message.show({ text: '修改成功', type: 'success' });
            this.editDialog = false;
            this.queryContract();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
        }
      });
    },
    openLicense(row) {
      this.$router.push({ name: 'uploadLicense' });
      sessionStorage.setItem('licenseId', row.ID);
    },
    submitAdd() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          const data = {
            SERVICE_ID: '10002',
            OTYPE: 1,
            SUPPLIER_ID: sessionStorage.getItem('supplierId'),
            QUALIFY_NAME: this.addForm.QUALIFY_NAME,
            EXPIRE_DAY: this.addForm.longTime ? '' : date(this.addForm.EXPIRE_DAY, '%F'),
            FILE_ARRAY: [],
          };
          http.post(data).then((result) => {
            this.$message.show({ text: '新增成功', type: 'success' });
            this.addDialog = false;
            this.queryContract();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
        }
      });
    },
    close(formName) {
      this.$refs[formName].resetFields();
      this.addDialog = false;
      this.editDialog = false;
    },
    addLicense() {
      this.addDialog = true;
    },
    queryContract() {
      const data = {
        SERVICE_ID: '10002',
        OTYPE: 6,
        SUPPLIER_ID: sessionStorage.getItem('supplierId'),
      };
      http.post(data).then((result) => {
        this.tableData = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
  created() {
    this.queryContract();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/supplierManage/supplierLicense.vue